












































































































































import {Component, Prop, Watch} from 'vue-property-decorator';
import VueElementLoading from 'vue-element-loading';
import '../user-management.scss';
import {IKeyCloakUser, IEbkItem, IGu, IRegion} from '../user-management-int';
import BaseUserLink from '../base-user-link';
import { BIconStarFill } from 'bootstrap-vue';
import axios from 'axios';
import { umFetch } from '../services/umFetch';

@Component({
  components: {
    'loading': VueElementLoading,
    'b-icon': BIconStarFill,
  }
})
export default class GuUserData extends BaseUserLink {
    private guBase: IGu[] = [];
    private guList: IGu[] = [];
    private regionBase: IRegion[] = [];
    private abpBase: IEbkItem[] = [];
    @Prop({default: "45"}) private oblRegion: string | undefined;
    private selectedUserGuList: IGu[] = [];
    private loading = false;
    private leftFilter = '';
    private rightFilter = '';
private filterRegion: string | null = null;
private filterAbp: number | null = null;
private showWithKgkpOnly = false;
public guWithKgkpCodes: string[] = [];
private gu_names_array: any[] = [];
private msuCheckboxEnabled = false;  // доступность чекбокса
private msuCheckboxChecked = false;  // состояние чекбокса (true/false)
private msuRegionPrefix: string | null = null; // для фильтрации ГУ по первым 4 цифрам региона
private showClosed: boolean = false;




private get filteredLeftGuList() {
    let result = this.leftFilterGuList;

    if (this.showWithKgkpOnly) {
        result = result.filter(item => this.hasKgkp(item.code));
    }

    if (this.showClosed) {
        result = result.filter(item => item.end_date !== '2050-12-31'); // считаем, что ГУ с end_date != '2050-12-31' закрытые
    }

    return result;
}


private async onChangeShowClosed() {
    await this.loadGuFromBase();
}

private updateMsuCheckboxState() {
    if (!this.filterRegion || this.filterAbp !== 124) {
        this.msuCheckboxEnabled = false;
        this.msuCheckboxChecked = false;
        return;
    }
    // Если регион не оканчивается на 0101
    this.msuCheckboxEnabled = !this.filterRegion.endsWith('0101');
    if (!this.msuCheckboxEnabled) this.msuCheckboxChecked = false;
}


        
        private hasKgkp(code: string): boolean {
            return this.guWithKgkpCodes.includes(code);
        }

    @Watch('selectedUser')
    async onPropertyChanged(value: IKeyCloakUser, oldValue: IKeyCloakUser) {
        this.loading = true;
        if (oldValue !== null) {
            this.selectedUserGuList = [];
            this.guList = [...this.guBase];
            this.guList.sort((a, b) => (a.code > b.code) ? 1 : -1);
        }
        await this.selectUser(value);
        await this.loadGuWithKgkpCodes(); // 🔧
        this.loading = false;
    }


       private get leftFilterGuList() {
    if (!this.guList) return [];

    const res: IGu[] = [];
    const filter = this.leftFilter?.trim().toLowerCase() || '';

    for (const item of this.guList) {
        const codeStr = item.code?.toString() || '';
        const nameStr = item.name_ru?.toString() || '';

        if (!filter || codeStr.toLowerCase().includes(filter) || nameStr.toLowerCase().includes(filter)) {
            res.push(item);
        }
    }

    return res;
}


        private get rightFilterGuList() {
            const res = [];
            for (const item of this.selectedUserGuList) {
                if (item.code.toString().includes(this.rightFilter)) {
                    res.push(item);
                } else if (item.name_ru.toString().includes(this.rightFilter)) {
                    res.push(item);
                }
            }
            return res;
        }

        private async loadRegions(user: IKeyCloakUser) {
            try {
                const response = await fetch('/api-py/get-user-regions-by-obl/' + this.oblRegion + '/' + user?.id);
                this.regionBase = await response.json() as IRegion[];
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки регионов', error.toString());
            }
        }

        private userLevels: string[] = [];

        get userLevelsList() {
            let result = '['
            for (const lv of this.userLevels) {
                result = result + lv + ','
            }
            if (result.substring(result.length - 1) == ',') {
                result = result.substring(0, result.length - 1) + ']'
            }
            if (result = '[') {
                result = '[2,3,4]'
            }
            return result
        }

        private async loadUserLevels(user: IKeyCloakUser) {
            try {
                const response = await fetch('/api-py/get-user-budget-level-only/' + user?.id);
                this.userLevels = await response.json();
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки уровней пользователя', error.toString());
            }
        }

        private async loadGuWithKgkpCodes() {
            try {
                const res = await fetch('/api-py/gu-with-kgkp');
                const data = await res.json();
                this.guWithKgkpCodes = data;

            } catch (e) {
                this.makeToast('danger', 'Ошибка загрузки ГУ с ГККП', e.toString());
            }
        }

    private async loadABP(user: IKeyCloakUser) {
        try {
            const response = await fetch('/api-py/get-dict-ved-abp-by-budgetlevel-user/' + this.userLevelsList + '/' + user?.id);
            this.abpBase = await response.json() as IEbkItem[];
            if (this.abpBase.length > 0) {
                const firstAbp: IEbkItem = {
                    id: 0,
                    gr: 0,
                    abp: 0,
                    name_ru: 'Все АБП',
                    name_kk: 'Все АБП',
                    beg_date: '2022-01-01',
                    end_date: '2022-01-01'
                }
                this.abpBase.unshift(firstAbp);
            }
        } catch (error) {
            this.makeToast('danger', 'Ошибка загрузки АБП', error.toString());
        }
    }

private async onChangeMsuCheckbox() {
    if (!this.msuCheckboxChecked) {
        await this.loadGuFromBase();
        return;
    }

    const regionPrefix = this.filterRegion?.substring(0, 4);
    if (!regionPrefix) return;

    try {
        const response = await axios.get(`/api-py/dict-gu-msu/${this.selectedUser.id}/${regionPrefix}/124/true`);
        const msuData: IGu[] = response.data.rows || []; // ✅ явно указываем тип

        // ❌ Убираем ГУ, которые уже выбраны
        const selectedCodes = new Set(this.selectedUserGuList.map(g => g.code));
        const filteredMsu: IGu[] = msuData.filter((msu: IGu) => !selectedCodes.has(msu.code));

        const existingCodes = new Set(this.guList.map(g => g.code));
        filteredMsu.forEach((msu: IGu) => {
            if (!existingCodes.has(msu.code)) {
                this.guList.push(msu);
                this.guBase.push(msu);
            }
        });
    } catch (e) {
        this.makeToast('danger', 'Ошибка загрузки МСУ', e.toString());
    }
}


private async loadGuFromBase() {
    try {
        // Если не выбран регион или АБП, очищаем списки
        if (!this.filterRegion || this.filterAbp === null) {
            this.guBase = [];
            this.guList = [];
            return;
        }

        // Формируем список АБП для запроса
        const selectedAbp = this.filterAbp === 0
            ? this.abpBase.filter(x => x.abp !== 0).map(x => x.abp)
            : [this.filterAbp];

        // Запрос к API с учетом включенного переключателя "Закрытые"
        const response = await fetch(
            `/api-py/dict-gu-by-region-abp/${this.filterRegion}/${selectedAbp}?include_closed=${this.showClosed}`
        );
        const data = await response.json();

        let guFromApi: IGu[] = Array.isArray(data.rows) ? data.rows : data;

        // Исключаем ГУ, которые уже выбраны пользователем
        const selectedCodes = new Set(this.selectedUserGuList.map(g => g.code));
        guFromApi = guFromApi.filter(g => !selectedCodes.has(g.code));

        // Заполняем левый список доступных ГУ
        this.guBase = [...guFromApi];
        this.guList = [...guFromApi];

        // Если включен МСУ чекбокс — подгружаем МСУ ГУ
        if (this.msuCheckboxChecked) {
            const regionPrefix = this.filterRegion.substring(0, 4);
            if (regionPrefix) {
                const msuRes = await axios.get(
  `/api-py/dict-gu-msu/${this.selectedUser.id}/${regionPrefix}/124/true/${this.showClosed}`
)

                const msuData: IGu[] = msuRes.data.rows || [];

                // Исключаем уже выбранные
                const filteredMsu = msuData.filter(msu => !selectedCodes.has(msu.code));

                const existingCodes = new Set(this.guList.map(g => g.code));
                filteredMsu.forEach(msu => {
                    if (!existingCodes.has(msu.code)) {
                        this.guList.push(msu);
                        this.guBase.push(msu);
                    }
                });
            }
        }

    } catch (error) {
        this.makeToast('danger', 'Ошибка загрузки данных', error.toString());
    }
}



public async addGuToSelectedUser(gu: IGu, save: boolean) {
    if (this.msuCheckboxChecked) {
        const regionPrefix = this.filterRegion?.substring(0, 4);
        if (regionPrefix) {
            const hasMsu = await this.checkUserMsu(regionPrefix);
            if (!hasMsu) return; // ❌ если нет МСУ, уведомление уже показано через $bvToast
        }
    }

    const exists = this.selectedUserGuList.some(v => v.code === gu.code);
    if (!exists) {
        this.selectedUserGuList.push(gu);
        this.guList = this.guList.filter(item => item.code !== gu.code);
    }

    if (save) await this.saveUserguData(this.selectedUser);
}


private async checkUserMsu(regionPrefix: string): Promise<boolean> {
    try {
        console.log('checkUserMsu called, regionPrefix:', regionPrefix, 'selectedUser.id:', this.selectedUser.id);

        const res = await fetch(`/api-py/check-user-msu/${this.selectedUser.id}/${regionPrefix}`);
        const data = await res.json();
        const hasMsu = data.hasMsu === true || data.hasMsu === 'true';

        if (!hasMsu) {
            setTimeout(() => {
                this.$bvToast.toast('Необходимо  привязать  МСУ по текущему региону во вкладке МСУ', {
                    title: 'Внимание',
                    variant: 'warning',
                    solid: true,
                    autoHideDelay: 5000,
                    toaster: 'b-toaster-top-center', // 🔹 центрирование
                });
            }, 0);
        }

        return hasMsu;
    } catch (e) {
        console.error('Ошибка проверки МСУ', e);
        setTimeout(() => {
            this.$bvToast.toast('Ошибка проверки МСУ: ' + e.toString(), {
                title: 'Ошибка',
                variant: 'danger',
                solid: true,
                autoHideDelay: 7000,
                toaster: 'b-toaster-top-center', // 🔹 центрирование
            });
        }, 0);
        return false;
    }
}








public async selectUser(user: IKeyCloakUser) {
    this.selectedUser = user;

    await this.loadGuWithKgkpCodes(); 
    await this.loadUserFuncGroup(user); 

        if (this.selectedUser !== null) {
            for (const item of this.selectedUserGuList) {
                for (const it of this.guList) {
                    if (it.code === item.code) {
                        const ind = this.guList.indexOf(it);
                        this.guList.splice(ind, 1);
                    }
                }
            }
        }
    }


        removeAllGu() {
            for (const abpListElement of this.selectedUserGuList) {
                this.guList.push(abpListElement)
            }
            this.guList.sort((a, b) => (a.code > b.code) ? 1 : -1);
            this.selectedUserGuList = []
            this.saveUserguData(this.selectedUser);
        }

public async addAllGu() {
    if (this.msuCheckboxChecked) {
        const regionPrefix = this.filterRegion?.substring(0, 4);
        if (regionPrefix) {
            const hasMsu = await this.checkUserMsu(regionPrefix);
            if (!hasMsu) return; // ❌ Если нет МСУ, уведомление уже показано
        }
    }

    this._addAllGuExecute(); // добавляем все доступные ГУ
}


private _addAllGuExecute() {
    let guToAdd = this.guList;
    if (this.showWithKgkpOnly) {
        guToAdd = guToAdd.filter(item => this.hasKgkp(item.code));
    }

    const newGuList = guToAdd.filter(
        gu => !this.selectedUserGuList.some(sel => sel.code === gu.code)
    );

    this.selectedUserGuList.push(...newGuList);
    this.selectedUserGuList.sort((a, b) => (a.code > b.code ? 1 : -1));

    this.guList = this.guList.filter(
        gu => !newGuList.some(sel => sel.code === gu.code)
    );

    this.saveUserguData(this.selectedUser);
}



        private removeGuFromSelectedUser(gu: IGu, save: boolean) {
            const ind = this.selectedUserGuList.indexOf(gu);
            this.selectedUserGuList.splice(ind, 1);
            this.guList.push(gu);
            this.guList.sort((a, b) => (a.code > b.code) ? 1 : -1);
            if (save) {
                this.saveUserguData(this.selectedUser);
            }
        }

        private async saveUserguData(user: IKeyCloakUser) {
            const guList: any = [];
            for (const item of this.selectedUserGuList) {
                const d = {
                    gu: item.code
                };
                guList.push(d);
            }
            
            if (user !== null) {
                const saveData = {
                    user_id: user?.id,
                    guList: guList
                };
                try {
                    await umFetch('/api-py/save-user-gu', {
                    method: 'POST',
                     headers: {
                     'Content-Type': 'application/json;charset=utf-8',
                    'Authorization': `Bearer ${this.$store.getters.token}`
                  },
                 body: JSON.stringify(saveData)
                });

                } catch (error) {
                    this.makeToast('danger', 'Ошибка сохранения данных: ' + user.id, error.toString());
                }
            }
        }

private async loadGuLikeCodeName(templ: string) {
    if (templ.length > 4) {
        this.filterRegion = null;
        this.filterAbp = null;
        try {
            const guResponse = await fetch('/api-py/dict-gu-region-like-code-name/' + this.oblRegion + '/' + templ);
            this.guBase = await guResponse.json() as IGu[];
            this.guList = [...this.guBase];
        } catch (error) {
            this.makeToast('danger', 'Ошибка поиска по маске : ' + templ, error.toString());
        }
    }
}


        private async load_gu_names_array() {
            const guResponse = await fetch('/api-py/dict-user-gu-names/' + this.selectedUser.id);
            this.gu_names_array = await guResponse.json();
        }

        private async loadGuByCode(code: string) {
            if (this.gu_names_array.length === 0) {
                await this.load_gu_names_array();
            }
            const res = this.gu_names_array.find(value => (value.code === code));
            if (res) {
                const rv: any[] = [];
                rv.push(res);
                this.gu_names_array.splice(this.gu_names_array.indexOf(res), 1);
                return rv
            } else {
                const guResponse = await fetch('/api-py/dict-gu-by-code/' + code);
                return await guResponse.json() as IGu[];
            }
        }

        right_max_count = 0;

private async loadUserFuncGroup(user: IKeyCloakUser) {
    if (user !== null) {
        try {
            this.loading = true;
            this.selectedUserGuList = [];
            const response = await fetch('/api-py/user-gu/' + user?.id);
            const data = await response.json();
            this.right_max_count = data.length;
            
            await this.loadGuWithKgkpCodes(); 
            
            for (const item of data) {
                const guData = await this.loadGuByCode(item.gu);
             for (const t of guData as IGu[]) {
    if (item.gu === t.code) {
       this.addGuToSelectedUser(t, false);

    }
}

            }
            this.selectedUserGuList.sort((a, b) => (a.code > b.code) ? 1 : -1);
        } catch (error) {
            this.loading = false;
            this.makeToast('danger', 'Ошибка загрузки данных ГУ для : ' + user.id, error.toString());
        } finally {
            this.loading = false;
        }
    }
}
public async mounted() {
    await this.loadUserLevels(this.selectedUser);
    await this.loadABP(this.selectedUser);
    await this.loadRegions(this.selectedUser);
    await this.loadGuFromBase(); 

        await this.loadGuWithKgkpCodes(); 

    if (this.selectedUser !== null) {
        await this.loadUserFuncGroup(this.selectedUser); 
    }
        this.updateMsuCheckboxState();
}


    }

    